import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type VirtualAccountState = {
  data: VirtualAccountType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  filters: VirtualAccountFilterState;
  dataType: TypeVirtualAccount[];
  dataStatus: StatusVirtualAccount[];
  dataDetailVA?: VirtualAccountDetailType;
};

export const virtualAccountInitialState: VirtualAccountState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  filters: {},
  dataType: [],
  dataStatus: [],
};

const slice = createSlice({
  name: 'virtualAccount',
  initialState: virtualAccountInitialState,
  reducers: {
    setListVirtualAccountAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: VirtualAccountType[];
        pagination?: PaginationAPI;
        totalElements?: number;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.data = [...state.data, ...payload.data];
      } else {
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setVirtualAccountLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setVirtualAccountFiltersAction(state, action: PayloadAction<VirtualAccountFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetVirtualAccountFiltersAction(state) {
      state.filters = {};
    },
    setVirtualAccountTypeAction(
      state,
      { payload }: PayloadAction<{ dataType: TypeVirtualAccount[] }>,
    ) {
      state.dataType = payload.dataType;
    },
    setVirtualAccountStatusAction(
      state,
      { payload }: PayloadAction<{ dataStatus: StatusVirtualAccount[] }>,
    ) {
      state.dataStatus = payload.dataStatus;
    },
    setVirtualAccountDetailAction(
      state,
      {
        payload,
      }: PayloadAction<{ dataDetailVA: VirtualAccountDetailType; pagination?: PaginationAPI }>,
    ) {
      state.dataDetailVA = payload.dataDetailVA;
      state.pagination = payload.pagination || state.pagination;
    },
    updateCardInVirtualAccountDetailAction(
      state,
      {
        payload,
      }: PayloadAction<{
        id: string;
        changes: Partial<ContentVirtualCards>;
      }>,
    ) {
      if (state.dataDetailVA?.virtualCards?.content) {
        state.dataDetailVA.virtualCards.content = state.dataDetailVA.virtualCards.content.map((item) => {
          if (item.id === payload.id) {
            // merge partial changes with existing card
            return {
              ...item,
              ...payload.changes,
            };
          }
          return item;
        });
      }
    },
  },
});

export const {
  setListVirtualAccountAction,
  setVirtualAccountLoading,
  setVirtualAccountFiltersAction,
  resetVirtualAccountFiltersAction,
  setVirtualAccountTypeAction,
  setVirtualAccountStatusAction,
  setVirtualAccountDetailAction,
  updateCardInVirtualAccountDetailAction,
} = slice.actions;
export default slice.reducer;
